import { useQuery } from '@tanstack/react-query';
import { getDashboardStats } from '../services/dashboardApi';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
};

export const useDashboardStats = () => {
  return useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: getDashboardStats,
    refetchInterval: 60000, // Refetch every minute
  });
};

export default useDashboardStats;
